module.exports = __webpack_public_path__ + "static/media/Listar.6fd7280d.svg";